import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

interface IncidenceProps {
  allowanceIncidence: number
}

const Incidence = ({ allowanceIncidence }: IncidenceProps) => {
  return (
    <Box flexDirection="row" justifyContent="spaceBetween">
      <Text.Normal>{i18n.t('time_off.allowance_tooltip.holiday')}</Text.Normal>
      <Text.Normal>{allowanceIncidence}</Text.Normal>
    </Box>
  )
}

export default observer(Incidence)
